import { RequestStatus } from 'legacy/lut/configs/service'
import {
  selectJBPSettings,
  selectJBPSettingsStatus,
} from 'legacy/lut/features/partner360/jbpSettings'
import { requestFetchJBPSettings } from 'legacy/lut/features/partner360/jbpSettings/api/requestFetchJBPSettings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

export const useJbpSettings = (isEnabled = true) => {
  const dispatch = useAppDispatch()
  const user = useSelector(selectUser)
  const jbpSettings = useSelector(selectJBPSettings)
  const status = useSelector(selectJBPSettingsStatus)

  const isLoaded = useMemo(() => {
    return jbpSettings.entryId > 0
  }, [jbpSettings.entryId])

  const isLoading = useMemo(() => {
    return status === RequestStatus.PENDING
  }, [status])

  useEffect(() => {
    if (!isLoaded || isEnabled) {
      dispatch(requestFetchJBPSettings(user))
    }
  }, [user, isLoaded, isEnabled, dispatch])

  return {
    jbpSettings,
    isLoaded,
    isLoading,
  }
}
